import { render } from "./ReportBase.vue?vue&type=template&id=52d47aa4"
import script from "./ReportBase.vue?vue&type=script&lang=js"
export * from "./ReportBase.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__